import { useEffect } from 'react';

type UseDialogTabControlProps = {
  dialogRef: React.RefObject<HTMLDialogElement>;
  focusTargetRef: React.RefObject<HTMLElement>;
};

export function useDialogTabControl({ dialogRef, focusTargetRef }: UseDialogTabControlProps) {
  useEffect(() => {
    const dialog = dialogRef.current;
    const focusTarget = focusTargetRef.current;

    const setTabNavigation = () => {
      const isOpen = dialog?.open ?? false;
      if (focusTarget) {
        focusTarget.setAttribute('aria-hidden', `${!isOpen}`);
        focusTarget.setAttribute('tabIndex', isOpen ? '0' : '-1');
      }
      if (dialog) {
        dialog.setAttribute('aria-hidden', `${!isOpen}`);
        dialog.setAttribute('tabIndex', isOpen ? '0' : '-1');
      }
    };

    if (!dialog) return;

    dialog.addEventListener('dialogopened', setTabNavigation);
    dialog.addEventListener('close', setTabNavigation);
    dialog.addEventListener('cancel', setTabNavigation);

    setTabNavigation();

    return () => {
      dialog.removeEventListener('dialogopened', setTabNavigation);
      dialog.removeEventListener('close', setTabNavigation);
      dialog.removeEventListener('cancel', setTabNavigation);
    };
  }, [dialogRef, focusTargetRef]);
}
